export interface Subscription {
  verified: boolean;
}
